// src/components/Dashboard/RoleDashboard/componentsRegistry.js

// ✅ ROLE-AWARE HEADER
import Header from "./Header";

// ✅ NOW ROLE DASHBOARD FOOTER (migrated from AgentDashboard)
import Footer from "./Footer";

// ✅ ROLE DASHBOARD INBOX
import Inbox from "./Inbox";

import Profile from "./Profile";

// ✅ NOW ROLE DASHBOARD SavedOpportunity (migrated from AgentDashboard)
import SavedOpportunity from "./SavedOpportunity";

// ✅ RoleDashboard VideoProfile
import VideoProfile from "./VideoProfile";

// ✅ Shared, role-aware components
import PostOpportunity from "./PostOpportunity";
import ViewPosts from "./RoleExtras/ViewPosts";
import Bookmarks from "./RoleExtras/Bookmarks";
import Notifications from "./RoleExtras/Notifications";

// ✅ Transfers adapter
import VSNTransfersAdapter from "./VSNTransfersAdapter";

const base = {
    Header,
    Footer,
    Inbox,
    Profile,
    SavedOpportunity,
    VideoProfile,
    PostOpportunity,
    ViewPosts,
    Bookmarks,
    Notifications,
    Transfers: VSNTransfersAdapter,
};

// All roles use same components for now.
const registry = {
    agent: { ...base },
    scout: { ...base },
    club: { ...base },
};

export default function getComponentsForRole(role = "agent") {
    return registry[role] || registry.agent;
}









